import React, { useState } from "react";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";

import { Dropdown, Link } from "@global";
import { Query } from "@graphql-types";
import { colors } from "@util/constants";
import { filterItemWithAndMethod } from "@util/helper";

import { Container, StandardLayoutContainer } from "@util/standard";

const JobWrapper = styled.div<{ isLast: boolean }>`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGrey};
  ${({ isLast }) => isLast && `border-bottom: none;`};
  margin-bottom: 90px;

  h3 {
    font-size: 25px;
    margin: auto 0 50px 0;
  }
  p {
    margin-bottom: 65px;
  }

  .viewButton {
    width: 100px;
    text-align: center;
    padding: 0;
    margin-bottom: 30px;
  }
`;

function CareersList() {
  const { allLever }: Query = useStaticQuery(graphql`
    {
      allLever {
        nodes {
          categories {
            location
            team
            department
          }
          lever_id
          hostedUrl
          text
          descriptionPlain
        }
      }
    }
  `);

  const locations = allLever.nodes.map(node => node.categories?.location);
  const teams = allLever.nodes.map(node => node.categories?.team);

  const dedupedLocations = [...new Set(locations)];
  const dedupedTeams = [...new Set(teams)];

  const [locationFilter, setLocationFilter] = useState("All");
  const [teamFilter, setTeamFilter] = useState("All");

  const allJobs = allLever.nodes;

  const filteredJobs = allJobs.filter(job => {
    if (job.categories == null) return null;

    return filterItemWithAndMethod(
      job.categories?.location,
      job.categories?.team,
      locationFilter,
      teamFilter,
    );
  });

  return (
    <StandardLayoutContainer tabletFlexDirection="column" margin="auto">
      <Container
        flexDirection="column"
        width="20%"
        tabletWidth="100%"
        margin="0 9% 0 0"
        tabletMargin="0 0 50px 0"
      >
        <Dropdown
          title="Locations"
          margin="0 0 25px 0"
          data={dedupedLocations}
          onChange={setLocationFilter}
        />
        <Dropdown title="Specialties" margin="0" data={dedupedTeams} onChange={setTeamFilter} />
      </Container>
      <Container flexDirection="column" width="80%" tabletWidth="100%">
        {filteredJobs.map((job, index) => {
          if (job == null) return null;
          if (job.categories?.department !== "ZURU Toys") return null;
          const isLast = index === filteredJobs.length - 1;
          return (
            <JobWrapper isLast={isLast} key={job.lever_id}>
              <Container justifyContent="space-between" tabletFlexDirection="column">
                <h3>{job.text}</h3>
                {job.hostedUrl && (
                  <Link
                    linkText="View"
                    externalLink={job.hostedUrl}
                    design="outlineDark"
                    className="viewButton"
                  />
                )}
              </Container>
            </JobWrapper>
          );
        })}
      </Container>
    </StandardLayoutContainer>
  );
}

export default CareersList;
